import { Grid, makeStyles } from "@material-ui/core";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";
import { AdminSignup } from "../../actions/auth";
import { useEffect, useRef } from "react";

const initialFValues = {
  fullName: "",
  phoneNo: "",
  email: "",
  password: "",
  username: "",
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const AdminSignUp = ({ NotifyMessage, setOpenPopup,getAllAdmin }) => {

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("fullName" in fieldValues)
      temp.fullName =
        fieldValues.fullName.length != 0 ? "" : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo = fieldValues.phoneNo.length != 0 ? "" : "This is required.";
    if ("password" in fieldValues)
      temp.password =
        fieldValues.password.length != 0 ? "" : "This field is required.";
    if ("username" in fieldValues)
      temp.username =
        fieldValues.username.length != 0 ? "" : "This is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      } else {
        temp.email = "";
      }
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });

      delete values.logginError;
      delete values.editing;
      delete values.submitting;

      AdminSignup(values).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err ,
            type: "error",
          });
        } else if (data.message) {
          NotifyMessage({
            message: "Account successfully created",
            type: "success",
          });
          setOpenPopup(false);
          getAllAdmin()
          resetForm();
        }
      });
    }
  };
   const firstFieldRef = useRef(null);
    useEffect(() => {
      if (firstFieldRef.current) {
        firstFieldRef.current.focus();
      }
    }, []);
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="fullName"
            label="Full Name"
            value={values.fullName}
            onChange={handleInputChange}
            error={errors.fullName}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="password"
            label="Password"
            value={values.password}
            onChange={handleInputChange}
            error={errors.password}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="username"
            label="Username "
            value={values.username}
            onChange={handleInputChange}
            error={errors.username}
          />
        </Grid>
        <Grid item xs={12} md={6}/>

        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={values.submitting ? "Sent..." : "Signup"}
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AdminSignUp;
